
























import Vue, { PropOptions } from 'vue';
import SSidebarLink from '../SSidebarLink/SSidebarLink.vue';

export default Vue.extend({
  name: 'SSidebarGroup',
  components: {
    SSidebarLink,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    icon: {
      required: false,
      type: String,
      default: 'add_circle_outline',
    },
    routes: {
      required: true,
      type: Array,
    } as PropOptions<any>,
  },
});
